/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { Table, Alert, Select, Tag, Button } from "antd";
import { ClearOutlined } from "@ant-design/icons";

import { HeaderForm } from "./HeaderForm";
import { Spinner } from "../../components/spinner/Spinner";
import { removeDuplicates } from "../../utils/utils";

import {
  useFetchOrders,
  useFilteredOrders,
  useFetchOrdersBy,
  useFilters,
} from "../../app/orders/mutations";

import { columns, InconsistentMsg, LogisticAlertMsg } from "./constants";
import "../../styles/orders/ordenes.scss";
import useState from "react-usestateref";

export const Orders = () => {
  const _useFilteredOrders = useFilteredOrders();
  const { selectedFilters, addFilter, removeFilter, resetFilters } =
    useFilters();
  const [statusValue, setStatusValue] = useState(null);
  
  const [isLoading, setIsLoading] = useState(false);
  const [queryParams, setQueryParams] = useState({});

  let {
    isFetching,
    isError,
    error,
    orders,
    refetch,
  } = useFetchOrders(queryParams);

  const handleSubmit = async (queries) => {
    setIsLoading(true);
    setQueryParams(queries);
    resetFilters();

    localStorage.removeItem('EDITED_ORDERS');
    localStorage.removeItem('CURRENT_ORDER');

    setTimeout(() => {
      refetch().finally(() => setIsLoading(false));
    }, 500);
  };

  const handleClear = (e) => {
    console.log(e);
  };

  let key =
    _useFilteredOrders.length === 0
      ? orders
      : _useFilteredOrders !== -1
      ? _useFilteredOrders
      : [];

  const handleStatusChange = (event) => {
    if (event === "ALL") return;
    addFilter({ label: "Estado", prop: "estado", value: event });
    useFetchOrdersBy();
    setStatusValue(null);
  };

  if (isError && error instanceof Error)
    return (
      <Alert
        message="Ocurrión un error"
        description={error.message}
        type="error"
        showIcon
      />
    );

  const ordersWithError = orders.filter(
    (order) => order.estado === "INCONSISTENCIA"
  ).length;

  const clientsDocuments =
    orders && orders.length > 0
      ? removeDuplicates(orders.map((order) => order.cedula))
      : [];

  const clientsOrders =
    orders && orders.length > 0
      ? removeDuplicates(orders.map((order) => order.ordenCompra))
      : [];

  const STATUSES_FILTER = removeDuplicates(key.map((o) => o.estado)).map(
    (o) => {
      return {
        value: o.toUpperCase(),
        label: o.toUpperCase(),
      };
    }
  );

  const handleFilterClose = (filter) => {
    removeFilter(filter);
    useFetchOrdersBy();
  };

  const handleFilterReset = () => {
    resetFilters();
    useFetchOrdersBy();
  };

  const handleOrdersWithError = () => {
    addFilter({ label: "Estado", prop: "estado", value: "INCONSISTENCIA" });
    useFetchOrdersBy();
  };

  return (
    <>
      <div className="orders">
        <div className="orders-header">
          <h2>Órdenes</h2>
        </div>
        <div className="orders-form">
          <HeaderForm
            onSubmit={handleSubmit}
            disabled={orders.length === 0 ? true : false}
            ordersIds={clientsOrders}
            documentsIds={clientsDocuments}
            isLoading={isLoading || isFetching}
          />
        </div>

        {selectedFilters && selectedFilters.length > 0 && (
          <div className="orders-filters">
            {selectedFilters.length > 0 && (
              <Button
                id="clear-filters-btn"
                type="link"
                icon={<ClearOutlined />}
                onClick={handleFilterReset}
              >
                Limpiar Filtros
              </Button>
            )}

            {selectedFilters &&
              selectedFilters.length > 0 &&
              selectedFilters.map((filter, index) => (
                <Tag
                  closable
                  key={index}
                  onClose={() => handleFilterClose(filter)}
                >
                  {filter.label}: <b>{filter.value}</b>
                </Tag>
              ))}
          </div>
        )}

        <div className="orders-table">
          {orders.length > 0 && (
            <div className="orders-table-header">
              <div className="table-header-messages">
                {ordersWithError > 0 && (
                  <InconsistentMsg
                    count={ordersWithError}
                    onClick={handleOrdersWithError}
                  />
                )}
              </div>
              <div className="table-header-filer">
                <Select
                  showSearch
                  style={{ width: 220 }}
                  placeholder="Estado Orden"
                  optionFilterProp="children"
                  size="medium"
                  onChange={handleStatusChange}
                  allowClear="true"
                  onClear={handleClear}
                  options={[...STATUSES_FILTER]}
                  value={statusValue}
                />
              </div>
            </div>
          )}

          <div className="orders-table-content">
            {isFetching && <Spinner tip="Cargando, por favor espere..." />}
            {!isFetching && (
              <Table
                columns={columns}
                dataSource={key}
                locale={{ emptyText: "No hay datos correspondientes" }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
